import {ResponseInnerMessage} from '@/hosted_fields/common/types';
import IframeClient from '@/hosted_fields/common/connection/client';
import '@/helpers/polyfills';
import LoggerPluginInterface from '@/plugins/logger/actions/interface';
import {ApiClientInterface} from '@/plugins/core/api/interface';
import {PluginConfig, PluginName} from '@/plugins/core/interface';
import LoggerApis from '@/plugins/logger/api';
import AbstractLogger from '@/utils/logger';
import {flattenObj, jsonify} from '@/utils/utility-functions';
import LogKeys from '@/constants/log-keys';
import {LogDataType, Metadata} from '@/plugins/logger/types';
import CommManagerInterface from '@/hosted_fields/master/interface';
import Logger from '@/utils/logger_old';

export default class LoggerActions extends AbstractLogger implements LoggerPluginInterface {
  config: PluginConfig;
  private commMgr: CommManagerInterface;
  private iframeClient: IframeClient;
  private loadConfig: Promise<any>;
  private configuration: any;
  private apiClient: ApiClientInterface;

  // Plugin initialize
  init(): Promise<void> {
    this.apiClient.addApis(LoggerApis);
    return Promise.resolve();
  }

  // Logger initialize
  initialize(): Promise<any> {
    return Promise.resolve();
  }

  setMetadata(meta: Metadata) {
    super.setMetadata(meta);
  }

  log(data: any, extra?: any) {
    // Read wrapper source from window variable
    const cbjsSource = window.CbJsSource;

    const payload = {
      data: flattenObj(
        {
          ...jsonify(data),
          ...extra,
          ...this.meta,
          key: LogKeys.LOGGING,
          log_data_type: LogDataType.INFO,
          ref_module: 'chargebee.js',
          ...(cbjsSource && {cbjs_source: cbjsSource}),
        },
        '_'
      ),
      type: 'kvl',
    };

    if (this.commMgr.pluginMan.isPluginLoaded(PluginName.CHECKOUT_UTILS)) {
      // Try getting customer_handle
      this.commMgr
        .getCheckoutUtilsPlugin()
        .then((checkoutUtilsPlugin) => checkoutUtilsPlugin.getHpData().customer_handle)
        .then((customerHandle) => {
          if (customerHandle) payload.data.customer_handle = customerHandle;
          this.apiClient.logger.track({}, payload);
        });
    } else {
      this.apiClient.logger.track({}, payload);
    }
  }

  logError(err: Error, extra?: any) {
    // Read wrapper source from window variable
    const cbjsSource = window.CbJsSource;

    const payload = {
      data: flattenObj(
        {
          ...jsonify(AbstractLogger.sanitizeError(err)),
          ...extra,
          ...this.meta,
          key: LogKeys.LOGGING,
          log_data_type: LogDataType.ERROR,
          ref_module: 'chargebee.js',
          ...(cbjsSource && {cbjs_source: cbjsSource}),
        },
        '_'
      ),
      type: 'kvl',
    };
    this.apiClient.logger.track({}, payload);
  }

  captureException(data) {
    const {error, extraData} = data;
    if (error) {
      Logger.error(error, extraData);
      this.logError(error, extraData);
    }
    return Promise.resolve({acknowledged: true});
  }

  captureKVL(data) {
    this.log(data);
    return Promise.resolve({acknowledged: true});
  }

  constructor(commMgr: CommManagerInterface) {
    super();
    this.commMgr = commMgr;
    this.apiClient = commMgr.apiClient;
    this.iframeClient = commMgr.connectionClient;
  }
}
